import { useState, useCallback } from 'react';
// import PropTypes from 'prop-types';
// material
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
//
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Iconify from '../Iconify';

import ListAtendentesOnline from './ListAtendentesOnline';
import ListClientesOnline from './ListClientesOnline';

// -----------------------------------------------------------------

const AccordionTitle = styled((props) => (
  <AccordionSummary disablegutters="true" {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(3.5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.default,
}));

function NavUsersSection() {
  const [expanded, setExpanded] = useState(true);
  const [clientesOnline, setClientesOnline] = useState(0);

  // Função otimizada para controlar o estado do Accordion
  const handleChange = useCallback((event, isExpanded) => {
    setExpanded(isExpanded);
  }, []);

  // Função otimizada para receber a contagem do componente filho
  const recebeNClientesOnline = useCallback((nClientes) => {
    setClientesOnline(nClientes ?? 0);
  }, []);

  return (
    <Box>
      <Accordion>
        <AccordionTitle
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Iconify
            icon="clarity:user-solid-badged"
            sx={{ width: 22, height: 22, ml: 1, mr: 2 }}
          />
          <Typography variant="body2">Atendentes Conectados</Typography>
        </AccordionTitle>
        <AccordionDetails>
          {/* renderiza todos atendentes disponiveis */}
          <ListAtendentesOnline />
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded} onChange={handleChange}>
        <AccordionTitle
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Iconify icon="entypo:chat" sx={{ width: 22, height: 22, ml: 1, mr: 2 }} />
          <Typography variant="body2">
            Chat Atendimento (
            {typeof clientesOnline === 'number' ? clientesOnline : 0})
          </Typography>
        </AccordionTitle>
        <AccordionDetails>
          {/* renderiza todos clientes disponiveis */}
          <ListClientesOnline nClientesOnline={recebeNClientesOnline} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default NavUsersSection;
